<template>
  <b-nav-item-dropdown
    right
    :text="dropdown.name"
  >
    <b-dropdown-item
      v-for="site in dropdown.sites"
      :key="site.id"
      class="navDropdownItem"
      :to="{ path: `/${dropdown.id}-${dropdown.name}/${site.id}-${site.name}`}"
    >
      {{ site.name }}
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'NavbarDropdown',
  data () {
    return {
      dropdownPosition: parseInt(this.$vnode.key)
    }
  },
  computed: {
    ...mapGetters([
      'getStoredNavEntryByPosition',
      'getStoredSitesByDropdownId'
    ]),
    dropdown () {
      const dropdown = this.getStoredNavEntryByPosition(this.dropdownPosition)
      dropdown.sites = this.getStoredSitesByDropdownId(dropdown.id)
      return dropdown
    }
  }
}
</script>

<style>
.navbar-light .navbar-nav .nav-link {
  color: inherit;
}

.dropdown ul {
  padding: 0;
}

</style>
